export default "__VITE_ASSET__owkCfKX4JTjmWE2UA1sNeQ__"